<template>
  <v-sheet>
    <div>
        <div :class="$vuetify.breakpoint.xs ? 'justify-center' : 'justify-end' " class="d-flex justify-end pa-5">
          <v-btn color="#4B2A66" dark outlined :to="{ name: 'register-shop' }"
            >Cadastrar negócio</v-btn
          >
        </div>
      <v-row justify="center" class="my-5">
        <v-avatar size="150" class="elevation-10">
          <img src="@/assets/logo-eye.png" />
        </v-avatar>
      </v-row>
      <v-row justify="center">
        <div class="text-h4">
          <strong>{{ user.name }}</strong>
        </div>
      </v-row>
      <v-row class="mx-7" justify="center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon large :to="{ name: 'profile_edit' }">
              <v-icon
                color="#4B2A66"
                dark
                v-bind="attrs"
                v-on="on"
                :to="{ name: 'profile_edit' }"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar Perfil</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click.stop="share_profile = true"
              v-if="!webShareApiSupported"
            >
              <v-icon
                color="#4B2A66"
                dark
                v-bind="attrs"
                v-on="on"
                :to="{ name: 'profile_edit' }"
              >
                mdi-share-outline
              </v-icon>
            </v-btn>
            <v-btn
              v-if="webShareApiSupported"
              icon
              href="javascript:void(0)"
              @click="share()"
            >
              <v-icon size="30" color="#4B2A66">mdi-share</v-icon>
            </v-btn>
          </template>
          <span>Compartilhar seu perfil</span>
        </v-tooltip>
      </v-row>
    </div>

    <div class="text-h6 text-center">Seus Salvos:</div>
    <v-container style="max-width: 100%">
      <div max-width="100%">
        <v-container>
          <div class="mx-auto mt-n4" max-width="100%">
            <v-container fluid>
              <v-row dense v-if="saved.length > 0">
                <v-col
                  v-for="saved_product in saved"
                  :key="saved_product._id"
                >
                  <!-- :cols="value.flex" :md="value.md" -->
                  <v-card>
                    <v-img
                      @click="
                        loadProduct(
                          saved_product.url_shop,
                          saved_product.url_product
                        )
                      "
                      :src="saved_product.imagem"
                      class="d-flex flex-column justify-space-between"
                      width="100%"
                      height="250px"
                    />
                    <v-card-title class="ma-0 pa-0 pl-2">{{
                      saved_product.product
                    }}</v-card-title>
                    <v-card-actions class="ma-0 pa-0">
                      <v-card-title class="text-button ma-1 pa-0"
                        >R$ {{ saved_product.value }}
                      </v-card-title>
                      <v-spacer />
                      <v-btn
                        icon
                        active
                        @click="
                          unsave(saved_product._id, saved_product.product_id)
                        "
                      >
                        <v-icon color="red darken-2">mdi-delete</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <p v-else style="text-align: center">Nenhum produto salvo!</p>
            </v-container>
          </div>
        </v-container>
      </div>
    </v-container>
    <v-dialog v-model="share_profile" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Compartilhe seu perfil com seus amigos
        </v-card-title>

        <v-container>
          <v-card height="30" class="d-flex justify-center align-center">
            <div class="text-subtitle-2">
              {{ url }}
            </div>
          </v-card>
        </v-container>
        <!--
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="pink darken-3" text @click="share_profile = false">
            Disagree
          </v-btn>

          <v-btn color="pink darken-3" text @click="share_profile = false">
            Agree
          </v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
export default {
  name: "Profile",
  data: () => ({
    user: [],
    saved: [],
    share_profile: false,
    products: [],
    deletedProduct: "",
    url: "",
  }),
  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
  },
  methods: {
    loadProduct(shop, url_product) {
      this.$axios.get("/product/" + url_product);
      this.$router.replace({
        path: "/negocio/" + shop + "/" + url_product,
      });
    },
    unsave(saved_id, product_id) {
      this.$axios
        .delete("/saved/" + saved_id + "/" + product_id)
        .then((response) => {
          this.deletedProduct = response.data;
        });
    },
    share() {
      if (navigator.share !== undefined) {
        navigator
          .share({
            title: "Olhadela",
            text: "Venha visualizar os meus produtos salvos!",
            url: this.url,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    },
  },
  mounted() {
    this.$axios.get("/user").then((response) => {
      this.user = response.data;
      this.url = "https://olhadela.digital/usuario/" + this.user.email;
    });
    this.$axios.get("/saved").then((response) => {
      this.saved = response.data;
    });
    document.title = `Olhadela - Perfil`;
  },
  watch: {
    deletedProduct: function () {
      this.$axios.get("/saved").then((response) => {
        this.saved = response.data;
      });
    },
  },
};
</script>
